import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PermissionsFull } from 'src/app/models/permissions/permissions-full';
import { Permissions } from 'src/app/models/permissions/permissions';
import { HttpService } from '../http/http.service';

import { UserService } from '../user/user.service';
import { PermissionService } from '../user/permission.service';

@Injectable({
    providedIn: 'root'
})
export class SettingService extends HttpService {
    private permissionSubject$ = new BehaviorSubject<(Permissions | null)>(null);
    private readonly dataStore: {permissions: (Permissions | null)} = {permissions: null};

    readonly permission$ = this.permissionSubject$.asObservable();

    constructor(private userService: UserService, private permissionService: PermissionService) {
        super();
    }

    getConfiguration(): Observable<void> {
        return new Observable<void>(observable => {
            this.getSettingsAndPermission().subscribe({
                next: (res: PermissionsFull) => {
                    this.userService.setStaffData(res.staff.username, '', res.staff.isTemporalPassword);
                    this.loadStaff(res);
                    const permissions: Permissions = this.parsedPermissions(res);
                    const idCenter = this.userService.getCenter()?.center?.id || 0;
                    const myCenter = res.centers.find(a => a.center.id === +idCenter);
                    this.permissionService.setPermissions(permissions);
                    this.userService.setCenters(res.centers);
                    if (myCenter) {
                        this.userService.setCenterModule(myCenter.modules);
                    }
                    this.dataStore.permissions = permissions;
                    this.nextPermissions();
                    observable.next();
                },
                error: () => observable.error()
            });
        });
    }

    updateCenter(center: any): void {
        this.userService.updateCenter(center.center);
        this.getConfiguration().subscribe(); // TODO: Comprobar con el cambio de centro
    }

    private loadStaff(res: any): void {
        this.userService.setUser(res.staff);
    }

    private getSettingsAndPermission(): Observable<PermissionsFull> {
        const url = 'settings';

        return this.get(url, { app: 'center', version: 1 }, this.noShowErrorNotification);
    }

    private parsedPermissions(permissions: PermissionsFull): Permissions {
        return  {
            centerOptions: permissions.centerOptions,
            staff: permissions.staff,
            staffPermissionFull: permissions.staffPermissionFull,
            staffMemberPermissions: permissions.staffPermissionFull.staffMemberPermissions,
            staffCenterPermission: permissions.staffPermissionFull.staffCenterPermission,
            chatCenter: permissions.chatCenter
        };
    }

    private nextPermissions(): void {
        this.permissionSubject$.next(this.dataStore.permissions);
    }
}
